import _ from '../utils'
import PAGE_TRANSITION_CONFIG from './config'
import FADE_TRANSITION from './transitions/fade'
import COVER_HORIZONTAL_TRANSITION from './transitions/cover-horizontal'
import COVER_VERTICAL_TRANSITION from './transitions/cover-vertical'
import barba from '@barba/core'

class PageTransitionClass {
    constructor() {
        this.pageTransition = document.documentElement.getAttribute( 'data-page-transtion' ) == 'true' ? true : false
        this.pageTransitionType = null

        this.pageTransition ? this.init() : null
    }

    init() {
        this._getPageTransitionType()
        this._runPageTransition()   
    }

    _getPageTransitionType() {
        if ( PAGE_TRANSITION_CONFIG.transition.getAttribute( 'data-transition-type' ) === 'FADE_TRANSITION' ) {
            this.pageTransitionType = FADE_TRANSITION
        }
        if ( PAGE_TRANSITION_CONFIG.transition.getAttribute( 'data-transition-type' ) === 'COVER_HORIZONTAL_TRANSITION' ) {
            this.pageTransitionType = COVER_HORIZONTAL_TRANSITION
        }
        if ( PAGE_TRANSITION_CONFIG.transition.getAttribute( 'data-transition-type' ) === 'COVER_VERTICAL_TRANSITION' ) {
            this.pageTransitionType = COVER_VERTICAL_TRANSITION
        }
    }

    _runPageTransition() {
        barba.init({
            prefetchIgnore: true,
            transitions: [ this.pageTransitionType ]
        })
    }
}

const PAGE_TRANSITION = new PageTransitionClass()